import { AxiosResponse } from "axios";
import {
  CreateFaqRequest,
  FaqResponse,
  ReorderFaqRequest,
  UpdateFaqRequest,
} from "../models/faq";
import { backend } from "../utils/axios";

const ROUTE = "/faqs";

interface FaqsServiceEndpoints {
  getAll: () => Promise<FaqResponse[]>;
  create: (data: CreateFaqRequest) => Promise<FaqResponse>;
  reorder: (data: ReorderFaqRequest) => Promise<FaqResponse>;
  getById: (id: string) => Promise<FaqResponse>;
  update: (id: string, data: UpdateFaqRequest) => Promise<FaqResponse>;
  delete: (id: string) => Promise<FaqResponse>;
}

export const FaqsService: FaqsServiceEndpoints = {
  getAll: () =>
    backend
      .get<FaqResponse[]>(ROUTE)
      .then(({ data }) => data)
      .catch(),
  create: (data) =>
    backend
      .post<CreateFaqRequest, AxiosResponse<FaqResponse>>(ROUTE, data)
      .then(({ data }) => data)
      .catch(),
  reorder: (data) =>
    backend
      .post<ReorderFaqRequest, AxiosResponse<FaqResponse>>(
        `${ROUTE}/reorder`,
        data
      )
      .then(({ data }) => data)
      .catch(),
  getById: (id) =>
    backend
      .get<FaqResponse>(`${ROUTE}/${id}`)
      .then(({ data }) => data)
      .catch(),
  update: (id, data) =>
    backend
      .put<UpdateFaqRequest, AxiosResponse<FaqResponse>>(`${ROUTE}/${id}`, data)
      .then(({ data }) => data)
      .catch(),
  delete: (id) =>
    backend
      .delete<FaqResponse>(`${ROUTE}/${id}`)
      .then(({ data }) => data)
      .catch(),
};
